import { render, staticRenderFns } from "./AssetsTable.vue?vue&type=template&id=5ec48598&scoped=true&"
import script from "./AssetsTable.vue?vue&type=script&lang=js&"
export * from "./AssetsTable.vue?vue&type=script&lang=js&"
import style0 from "./AssetsTable.vue?vue&type=style&index=0&id=5ec48598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec48598",
  null
  
)

export default component.exports